const DomainBanner = ({domain, title, body}) => {
  return (
    <>
      <div className={`banner domains ${domain} section `} id="home">
        <div className="banner-overlay"></div>
        <div className="banner-content">
          <h1>{title}</h1>
          <p>
            {body}
          </p>
        </div>
        <div className="wave-section">
          <div className="wawes">
            <div className="wave" id="wave1"></div>
            <div className="wave" id="wave2"></div>
            <div className="wave" id="wave3"></div>
            <div className="wave" id="wabe4"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DomainBanner;
